import {Department} from '@app/core/models/department.model';
import {Tenant} from '@app/core/models/tenant.model';
import {QMIntegration} from '@app/core/models/QMIntegration.model';
import {RoundingRule} from '@app/core/models/roundingRule.model';
import {IPosIntegrationModel} from '@app/core/models/quickpos-integration.model';

export interface IDepartmentSettingsState {
	integrations: QMIntegration[];
	department: Department;
	editingDepartment: Department;
	tenant: Tenant;
	editingTenant: Tenant;
	isLoading: boolean;
	isTenantLoading: boolean;
	roundingRules: RoundingRule[];
	quickPosIntegration: IPosIntegrationModel;
}

export const initialDepartmentSettingsState: IDepartmentSettingsState = {
	integrations: [],
	department: undefined,
	editingDepartment: null,
	tenant: undefined,
	editingTenant: undefined,
	isLoading: false,
	isTenantLoading: false,
	roundingRules: [],
	quickPosIntegration: null,
};
